/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_File_Tree_Disclaimer_Title_DescriptionInputs */

const es_components_file_tree_disclaimer_title_description = /** @type {(inputs: Components_File_Tree_Disclaimer_Title_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los valores mostrados son aproximados. En la mayoría de los casos, la optimización inteligente de Nexata reduce el consumo real, permitiéndote almacenar más de lo indicado y aprovechar mejor tu espacio disponible.`)
};

const en_components_file_tree_disclaimer_title_description = /** @type {(inputs: Components_File_Tree_Disclaimer_Title_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The displayed storage values are approximate. In most cases, Nexata’s intelligent optimization reduces the real space consumed, allowing you to store more than what the indicator suggests maximizing efficiency without extra effort.`)
};

/**
* | output |
* | --- |
* | "The displayed storage values are approximate. In most cases, Nexata’s intelligent optimization reduces the real space consumed, allowing you to store more th..." |
*
* @param {Components_File_Tree_Disclaimer_Title_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_file_tree_disclaimer_title_description = /** @type {((inputs?: Components_File_Tree_Disclaimer_Title_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_File_Tree_Disclaimer_Title_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_file_tree_disclaimer_title_description(inputs)
	return en_components_file_tree_disclaimer_title_description(inputs)
});
export { components_file_tree_disclaimer_title_description as "components.file_tree.disclaimer_title_description" }